import React from 'react'

const Tasks = () => {
  return (
    <>
      Tasks
    </>
  )
}

export default Tasks
